import React from 'react';
import {
  Box, List, ListItem, ToggleButton, useTheme,
} from '@mui/material';
import { styled } from '@mui/system';
import { QuestionOption } from './models/Question';

type PollQuestionComponentProps = {
  options?: QuestionOption[];
  onClick?: (...event: unknown[]) => void;
  ['data-testid']?: string;
};

const MCQuestionTextBox = styled(Box)(({ theme }) => ({
  paddingLeft: theme.spacing(1),
  fontSize: theme.spacing(2),
  fontWeight: 400,
  lineHeight: 1,
}));

export default function PollQuestionComponent({
  options,
  onClick,
  'data-testid': dataTestId,
}: PollQuestionComponentProps) {
  const theme = useTheme();
  const handleClick = (value: string) => {
    if (onClick) {
      // pass data to the parent component
      onClick(value);
    }
  };

  return (
    <Box
      sx={{
        width: '100%',
      }}
      data-testid={dataTestId}
    >
      <List>
        {options &&
          options.map((item, index) => (
            <ListItem disablePadding key={index}
              sx={{
                mb: theme.spacing(2.5),
              }}>
              <ToggleButton
                value={item.value || item.display}
                selected={item.isSelected}
                onChange={() => handleClick(item.value || item.display)}
                sx={{
                  width: '100%',
                  border: `1px solid ${theme.palette.common.black}`,
                  justifyContent: 'center',
                  padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`,
                  borderRadius: theme.spacing(10),
                  color: theme.palette.common.black,
                }}
              >
                <MCQuestionTextBox >
                  {item.display}
                </MCQuestionTextBox>
              </ToggleButton>
            </ListItem>
          ))
        }
      </List>
    </Box>
  );
}
